var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.173,
    height: 13.885
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "icon / check-square",
    d: "M11.452 13.385H2.433A1.9 1.9 0 01.5 11.452V2.433A1.9 1.9 0 012.433.5H9.52a.61.61 0 01.644.644.61.61 0 01-.644.644H2.433a.61.61 0 00-.644.644v9.02a.61.61 0 00.644.644h9.02a.61.61 0 00.644-.644v-4.51a.644.644 0 111.288 0v4.51a1.9 1.9 0 01-1.933 1.933zm-4.51-4.51a.585.585 0 01-.451-.193L4.559 6.749a.625.625 0 010-.9.624.624 0 01.9 0l1.483 1.48L13.579.693a.623.623 0 01.9 0 .637.637 0 01.193.451.637.637 0 01-.193.451L7.394 8.682a.583.583 0 01-.452.193z",
    fill: "#222b45",
    stroke: "#f8af00"
  })));
}

export default SvgIconCheckSquare;